import qs from 'qs'

export const queryMenusSiteNav = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      filters: {
        slug: {
          $eq: 'site-nav'
        }
      },
      nested: true,
      populate: {
        items: {
          populate: {
            education_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            education_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            event_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            events_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            exhibition_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            exhibitions_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            home_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            journal_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            journals_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            page_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            press_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            },
            project_entry: {
              fields: ['title', 'slug', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'slug', 'locale'],
                }
              }
            },
            projects_page: {
              fields: ['title', 'locale'],
              populate: {
                localizations: {
                  fields: ['title', 'locale'],
                }
              }
            }
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `menus?${query}`
}
